export const pageInstructorData = [
    {
        id: 1,
        name: "SDR",
        value: "sdr"
    },
    {
        id: 2,
        name: "PDM",
        value: "pdm"
    },
      {
    id: 3,
    name: "Cyber Security",
    value: "cyber_security",
  },
]